import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
	title: {
		marginTop: theme.spacing(4),
	},
	nameInput: {
		marginTop: theme.spacing(2),
	},
}));
